// Repopulates the LoyaltyLion points and price spans after a variant change.
// Changing variant re-renders the price wrapper and .js-stock-info from the
// section HTML, so the data-lion-* spans (the PDP loyalty banner and the
// price-in-points) come back empty until LoyaltyLion re-reads the DOM.
// Also adds thousands separators to the raw points figure LoyaltyLion writes.
(function () {
  function refreshLionUI() {
    if (window.loyaltylion?.ui?.refresh) {
      window.loyaltylion.ui.refresh();
      return;
    }

    // LoyaltyLion's SDK loads async, so wait up to 3s for it.
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (window.loyaltylion?.ui?.refresh) {
        window.loyaltylion.ui.refresh();
        clearInterval(interval);
      } else if (attempts >= 30) {
        clearInterval(interval);
      }
    }, 100);
  }

  // Re-triggers the observer below, but the text is already formatted by then.
  function formatPoints(span) {
    var raw = (span.textContent || '').replace(/[^0-9]/g, '');
    if (raw === '') return;

    var formatted;
    try {
      formatted = parseInt(raw, 10).toLocaleString('en-GB');
    } catch (e) {
      return;
    }
    if (span.textContent !== formatted) span.textContent = formatted;
  }

  var pointsObserver = null;

  // Re-run after a variant change: the old spans are detached by then.
  function watchPointsSpans() {
    if (pointsObserver) {
      pointsObserver.disconnect();
      pointsObserver = null;
    }

    var spans = document.querySelectorAll(
      '.product__lower-loyalty [data-lion-points-for-product-id]'
    );
    if (!spans.length || typeof MutationObserver === 'undefined') return;

    pointsObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        var node = record.target;
        var element = node.nodeType === 1 ? node : node.parentElement;
        var span = element && element.closest('[data-lion-points-for-product-id]');
        if (span) formatPoints(span);
      });
    });

    spans.forEach(function (span) {
      formatPoints(span);
      pointsObserver.observe(span, { childList: true, subtree: true, characterData: true });
    });
  }

  function onVariantChange() {
    refreshLionUI();
    watchPointsSpans();
  }

  function attachVariantListener() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    } else {
      setTimeout(attachVariantListener, 100);
    }
  }

  attachVariantListener();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchPointsSpans);
  } else {
    watchPointsSpans();
  }
})();
